/* Size chart modal — open on click of any [data-size-chart-trigger],
   close on backdrop click, [data-size-chart-close] click, or Escape. */
(function () {
  function openModal(modal) {
    modal.hidden = false;
    // Move focus to the close button for accessibility
    const closeBtn = modal.querySelector('[data-size-chart-close]');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
    }
  }

  function closeModal(modal) {
    modal.hidden = true;
  }

  function handleClick(event) {
    const trigger = event.target.closest('[data-size-chart-trigger]');
    if (trigger) {
      event.preventDefault();
      const href = trigger.getAttribute('href');
      const id = href && href.startsWith('#') ? href.slice(1) : null;
      const modal = id ? document.getElementById(id) : document.querySelector('.size-chart-modal');
      if (modal) openModal(modal);
      return;
    }

    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      const modal = closer.closest('.size-chart-modal');
      if (modal) closeModal(modal);
    }
  }

  function handleKey(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.size-chart-modal').forEach((m) => {
      if (!m.hidden) closeModal(m);
    });
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('keydown', handleKey);
})();
